import { tickspeed, tickspeedUpgrades } from "./tickspeed";
import { AD } from "./antimatter-dimensions";
import { AM } from "./antimatter";
import { DT } from "./dilated-time";
import { EP } from "./eternity-points";
import { eternities } from "./eternities";
import { galaxies } from "./galaxies";
import { gamespeed } from "./gamespeed";
import { general } from "./general";
import { ID } from "./infinity-dimensions";
import { infinities } from "./infinities";
import { IP } from "./infinity-points";
import { replicanti } from "./replicanti";
import { TD } from "./time-dimensions";
import { TP } from "./tachyon-particles";

export const multiplierTabValues = {
  general,
  AM,
  AD,
  ID,
  TD,
  IP,
  EP,
  TP,
  DT,
  tickspeed,
  tickspeedUpgrades,
  galaxies,
  infinities,
  eternities,
  gamespeed,
  replicanti,
};
